import React from 'react';
import { useFormContext } from '../FormContext';
import { FormStep } from '../FormStep';
import { FormButtons } from '../FormButtons';
import { ColorSelector } from '../ColorSelector';
export const ColorStep: React.FC = () => {
  const {
    formData,
    handleOptionSelect,
    goToPreviousStep,
    goToNextStep
  } = useFormContext();
  return <FormStep title="Welke kleur heeft uw voorkeur?" description="Selecteer de kleur die het beste bij uw woning past." isActive={true} data-id="element-842">
      <ColorSelector selectedColor={formData.color} onSelect={color => handleOptionSelect('color', color)} data-id="element-843" />
      <FormButtons onPrevious={goToPreviousStep} onNext={goToNextStep} isNextDisabled={!formData.color} data-id="element-844" />
    </FormStep>;
};